/* mehlographylab cart discount form
 * - Ajax Cart API: POST /cart/update.js with { discount }
 * - 適用可否は cart.discount_codes[].applicable で判定
 * - 成功時：緑メッセージ表示 → ページリロードで反映（Ajax 差し替えはしない）
 * - 失敗時：赤メッセージのみ、リロードせず
 */
const MHL_DISCOUNT_RELOAD_DELAY = 600;

class MhlCartDiscount extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('.mhl-cart-discount__form');
    this.input = this.querySelector('.mhl-cart-discount__input');
    this.submit = this.querySelector('.mhl-cart-discount__submit');
    this.message = this.querySelector('.mhl-cart-discount__message');

    this.form.addEventListener('submit', this.onSubmit.bind(this));
    this.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    const removeBtn = event.target.closest('[data-discount-remove]');
    if (!removeBtn) return;
    event.preventDefault();
    const codeToRemove = removeBtn.dataset.discountRemove;
    this.applyDiscount(this.buildRemainingCodes(codeToRemove), { isRemove: true });
  }

  onSubmit(event) {
    event.preventDefault();
    const raw = (this.input.value || '').trim();
    if (!raw) return;
    const existing = this.getAppliedCodes().map((d) => d.code);
    const next = Array.from(new Set([...existing, raw]));
    this.applyDiscount(next, { newCode: raw });
  }

  getAppliedCodes() {
    try {
      const parsed = JSON.parse(this.dataset.applied || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  buildRemainingCodes(codeToRemove) {
    return this.getAppliedCodes()
      .map((d) => d.code)
      .filter((c) => c.toLowerCase() !== codeToRemove.toLowerCase());
  }

  setLoading(loading) {
    this.classList.toggle('mhl-cart-discount--loading', loading);
    this.submit.disabled = loading;
    const spinner = this.submit.querySelector('.mhl-cart-discount__spinner');
    if (spinner) spinner.hidden = !loading;
  }

  setMessage(text, kind) {
    this.message.textContent = text || '';
    this.message.classList.remove('mhl-cart-discount__message--error', 'mhl-cart-discount__message--success');
    if (kind) this.message.classList.add(`mhl-cart-discount__message--${kind}`);
  }

  async applyDiscount(codes, ctx = {}) {
    this.setLoading(true);
    this.setMessage('', null);

    const body = JSON.stringify({ discount: codes.join(',') });

    try {
      const res = await fetch(`${window.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body,
      });
      const cart = await res.json();

      // Shopify は無効コード時に 422 を返すことがある
      if (cart.status && cart.status >= 400) {
        this.setMessage(ctx.newCode ? this.t('invalid') : this.t('error'), 'error');
        this.setLoading(false);
        return;
      }

      // 新規適用時：applicable 判定
      if (ctx.newCode) {
        const list = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
        const applied = list.find(
          (d) => d.code && d.code.toLowerCase() === ctx.newCode.toLowerCase()
        );
        if (!applied || applied.applicable === false) {
          this.setMessage(this.t('invalid'), 'error');
          this.setLoading(false);
          return;
        }
        const isShipping = (cart.cart_level_discount_applications || []).some(
          (d) => d.code === applied.code && d.target_type === 'shipping_line'
        );
        this.setMessage(isShipping ? this.t('shipping_note') : this.t('applied'), 'success');
      } else if (ctx.isRemove) {
        this.setMessage(this.t('removed'), 'success');
      }

      // 成功 → 緑メッセージを見せてからリロード
      setTimeout(() => {
        window.location.reload();
      }, MHL_DISCOUNT_RELOAD_DELAY);
    } catch (err) {
      this.setMessage(this.t('error'), 'error');
      this.setLoading(false);
      console.error('[mhl-cart-discount]', err);
    }
  }

  t(key) {
    const dict = (window.mhlCartDiscountStrings || {});
    return dict[key] || '';
  }
}

if (!customElements.get('mhl-cart-discount')) {
  customElements.define('mhl-cart-discount', MhlCartDiscount);
}
